<template>
  <div class="page-wrapper">
    <navigation adaption />
    <pulldown-page class="page background-white" background="white" :refresh="pulldown" color="#333333" >
      <div class="top text-gray">
        <span class="back" @click="backHome" v-if="shouldShowBackButton">返回首页</span>
      </div>
      <div class="content flex-column">
        <div class="status-top flex-column">
          <div class="icon" v-if="statusIconInfo">
            <lottie ref="waitAnimation"
                    :options="animationOptions.wait"
                    v-show="['REVIEWING','REVIEWING_GUIDE_UP','LOANING'].includes(this.status)"
                    v-on:animCreated="waitAnimationCreated"
            />
            <lottie ref="successAnimation"
                    :options="animationOptions.success"
                    v-show="['SUCCESS'].includes(this.status)"
                    v-on:animCreated="successAnimationCreated"
            />
            <lottie ref="failAnimation"
                    :options="animationOptions.fail"
                    v-show="['FAILURE', 'FAILURE_REAL_TIME_REFUND'].includes(this.status)"
                    v-on:animCreated="failAnimationCreated"
            />
          </div>
          <img src="./image/icon_up_result_failure_single.png" class="icon" v-else>
          <div class="title text-dark">{{ statusTitle }}</div>
          <div class="desc text-gray" v-html="statusDesc" />
        </div>
        <div class="status-content">
          <template v-if="[statusKeys.REVIEWING,statusKeys.LOANING].includes(status)">
            <up-loan-back-only />
          </template>
          <template v-else-if="status===statusKeys.REVIEWING_GUIDE_UP">
            <up-loan-reviewing-guide-up :result="guideInfo" @onBuy="buyAction"/>
          </template>
          <template v-else-if="status===statusKeys.SUCCESS">
            <up-loan-success :result="result" />
          </template>
          <template v-else-if="status===statusKeys.FAILURE">
            <up-loan-failure-all
              v-if="result.upCardRealTimeRefund === 'N'"
              :result="result"
              @onRefund="toUpDetail"
            />
          </template>
          <template v-else-if="status===statusKeys.FAILURE_SINGLE">
            <up-loan-failure-single
              :result="result"
              @onUpLoanFailure="toUpDetail"
            />
          </template>
        </div>
      </div>
      <call-service-button
        class="service"
        @onCall="showServicePop"
        v-if="[statusKeys.FAILURE, statusKeys.FAILURE_SINGLE, statusKeys.FAILURE_REAL_TIME_REFUND].includes(status)"
      />
    </pulldown-page>
    <nd-dialog
      v-model="guidePopVisible"
      :closeBtn="true"
      :footer="false"
      class="up-result-guide-pop"
    >
      <div
        data-sensors-exposure-property-caseId="UP"
        data-sensors-exposure-event-name="PopupDisplay"
      >
        <div class="top text-yellow flex-row">
          <div class="left text-yellow flex-column">
            <div>恭喜您，</div>
            <div>获得100%提额特权</div>
            <div class="amount text-yellow">{{guideInfo.upLimit}}元</div>
          </div>
          <img src="./image/icon_up_result_pop__001.png" class="right">
        </div>
        <img src="./image/icon_up_result_pop__002.png" class="middle">
        <div class="bottom">
          <div class="buy-button" @click="buyAction" data-sensors-click>
            <span class="price text-white">100%提额 ¥{{ guideInfo.discountPrice }}</span>
            <span class="origin line-through text-white">原价 ¥{{ guideInfo.price }}</span>
            <span class="ui-bubble" v-if="guideInfo.expireDate && (guideInfo.expireDate - new Date().getTime() >0)">
              <van-count-down
                :time="guideInfo.expireDate - new Date().getTime()"
                :format="dateFormat"
              />&nbsp;后涨价
            </span>
          </div>
          <div class="protocol text-yellow">开通即同意<span class="underlined" @click="protocolAction">《会员用户协议》</span></div>
        </div>
      </div>
    </nd-dialog>
    <service-jw v-model="servicePopVisible" />
    <version-tips v-model="showVersionTips" />
  </div>
</template>

<script>
// images
import { fail, wait, success } from '@/assets/json/index'
// components
import UpLoanSuccess from './components/upCard/up_loan_success.vue'
import UpLoanFailureAll from './components/upCard/up_loan_failure_all.vue'
import UpLoanFailureSingle from './components/upCard/up_loan_failure_single.vue'
import UpLoanReviewingGuideUp from './components/upCard/up_loan_reviewing_guide_up.vue'
import UpLoanBackOnly from './components/upCard/up_loan_back_only.vue'
import callServiceButton from '@/components/service-button'
import { getKey, setKey, isAndroid, versionStringCompare } from '@/assets/utils'
import { WHPay } from '@/assets/buyVip'

import { hasNativeMethod } from '@/assets/jsBridge'
import Lottie from 'vue-lottie'
import { mapActions } from 'vuex'
import { mockHrefJump } from '../../assets/utils'

const StatusKey = {
  REVIEWING: 'REVIEWING',
  REVIEWING_GUIDE_UP: 'REVIEWING_GUIDE_UP',
  LOANING: 'LOANING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  FAILURE_SINGLE: 'FAILURE_SINGLE',
  FAILURE_REAL_TIME_REFUND: 'FAILURE_REAL_TIME_REFUND'
}

const StatusInfos = {
  REVIEWING: {
    title: '提现审核中',
    desc: '我们正在加急为您审核，请您耐心等待'
  },
  REVIEWING_GUIDE_UP: {
    title: '提现审核中',
    desc: '我们正在加急为您审核，请您耐心等待'
  },
  LOANING: {
    title: '提现成功，放款中',
    desc: '我们正在为您放款,预计两天内到账。<br />为不影响放款进度,请留意接听我们的服务监督电话'
  },
  SUCCESS: {
    title: '已为您放款成功！',
    desc: '已为您放款，具体以银行实际到账时间为准'
  },
  FAILURE: {
    title: '资方放款失败',
    desc: '放款被拒7个工作日自动退款'
  },
  FAILURE_SINGLE: {
    title: '请查看您的放款结果',
    desc: '具体以银行实际到账时间为准'
  },
  FAILURE_REAL_TIME_REFUND: {
    title: '资方放款失败',
    desc: '提额额度放款失败，已为您申请退款。<br />7个工作日完成退款，请注意查收'
  }
}

const StatusStrategies = {
  'GUIDE_UP': (result) => {
    return StatusKey.REVIEWING_GUIDE_UP
  },
  'UP_PROCESS_ONE': (result) => {
    const loanStatusVoEnum = result?.loanStatusVoEnum
    switch (loanStatusVoEnum) {
      case 'LOAN_AUDIT':
      case 'LOAN_WAIT_VIP':
      case 'LOAN_WAIT_UP':
        return StatusKey.REVIEWING
      case 'LOANING':
        return StatusKey.LOANING
      case 'LOAN_PASSED':
        return StatusKey.SUCCESS
      case 'LOAN_FAILURE':
      case 'APPLY_FAIL':
      case 'WITHDRAWALS_REJECTED':
        return result?.upCardRealTimeRefund === 'Y' ? StatusKey.FAILURE_REAL_TIME_REFUND : StatusKey.FAILURE
      default:
        return StatusKey.REVIEWING
    }
  },
  'UP_PROCESS_MANY': (result) => {
    const loanInfos = result?.processLoanInfos
    const loanStatusVoEnum = result?.loanStatusVoEnum
    if (['LOAN_AUDIT', 'LOAN_WAIT_VIP', 'LOAN_WAIT_UP'].includes(loanStatusVoEnum)) {
      return StatusKey.REVIEWING
    }
    if (loanStatusVoEnum === 'LOANING') {
      return StatusKey.LOANING
    }
    const allSuccess = loanInfos.every(item => item.loanStatusVoEnum === 'LOAN_PASSED')
    const allFailure = loanInfos.every(item => ['LOAN_FAILURE', 'APPLY_FAIL', 'WITHDRAWALS_REJECTED'].includes(item.loanStatusVoEnum))
    if (allSuccess) {
      // 全部成功
      return StatusKey.SUCCESS
    } else if (allFailure) {
      // 全部失败
      return result?.upCardRealTimeRefund === 'Y' ? StatusKey.FAILURE_REAL_TIME_REFUND : StatusKey.FAILURE
    } else {
      // 部分成功
      return StatusKey.FAILURE_SINGLE
    }
  }
}

export default {
  data () {
    return {
      result: {},
      guideInfo: {},
      guidePopVisible: false,
      showVersionTips: false,
      polling: null, // 审核中轮询
      statusKeys: { ...StatusKey },
      statusInfos: { ...StatusInfos },
      statusStrategies: { ...StatusStrategies },
      servicePopVisible: false,
      statusIconInfo: null,
      animationOptions: {
        wait: { animationData: wait },
        success: { animationData: success, loop: false },
        fail: { animationData: fail, loop: false }
      },
      anims: {
        wait: null,
        success: null,
        fail: null
      }
    }
  },
  components: {
    UpLoanSuccess,
    UpLoanFailureAll,
    UpLoanFailureSingle,
    UpLoanReviewingGuideUp,
    UpLoanBackOnly,
    callServiceButton,
    'lottie': Lottie,
    serviceJw: () => import('@/components/service-jw')
  },
  async created () {
    await this.getLoanResult()
    await this.getProductInfo()
    this.$bus.$emit('ready')
    this.checkShouldShowGuidePop()
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.polling)
    next((vm) => {})
  },
  computed: {
    statusTitle () {
      const info = this.statusInfos[this.status]
      return info?.title || ''
    },
    statusDesc () {
      const info = this.statusInfos[this.status]
      return info?.desc || ''
    },
    status () {
      /**
       * GUIDE_UP:引导购买up卡
       * UP_PROCESS_ONE:up卡单笔提现流程，即使用up有效额度提现流程
       * UP_PROCESS_MANY:up卡单多笔提现流程
       */
      const upCardProcess = this.result?.upCardProcess
      const strategy = this.statusStrategies[upCardProcess]
      if (strategy) {
        return strategy(this.result)
      }
    },
    dateFormat () {
      if (this.guideInfo.expireDate - new Date().getTime() > 86400000) {
        return 'DD天HH:mm:ss'
      } else if (this.guideInfo.expireDate - new Date().getTime() > 3600000) {
        return 'HH:mm:ss'
      } else {
        return 'mm:ss'
      }
    },
    needAutoRefresh () {
      return [this.statusKeys.REVIEWING, this.statusKeys.REVIEWING_GUIDE_UP, this.statusKeys.LOANING].includes(this.status)
    },
    shouldShowBackButton () {
      const onlyOneBillSuccess = (this.status === this.statusKeys.SUCCESS && this.result.upCardProcess === 'UP_PROCESS_ONE')
      return ![this.statusKeys.REVIEWING, this.statusKeys.LOANING].includes(this.status) && !onlyOneBillSuccess
    }
  },
  methods: {
    ...mapActions('withdraw', ['getLoanResultX']),
    ...mapActions('authentication', ['upGuideInfo']),
    async getLoanResult () {
      const response = await this.getLoanResultX({
        loanApplyNo: this.$route.query.loanApplyNo
      })
      if (response.success) {
        this.result = response.data
        if (this.isEmptyString(this.result.upCardProcess)) {
          this.$router.replace(`/withdraw/result2?loanApplyNo=${this.$route.query.loanApplyNo}`)
          return
        }
        this.configLottieData()
        if (this.needAutoRefresh) {
          if (!this.polling) {
            this.polling = setInterval(async () => {
              await this.getLoanResult()
            }, 10000)
          }
        } else {
          clearInterval(this.polling)
        }
      }
    },
    configLottieData () {
      let anim = null
      let hideAnims = []
      if (['REVIEWING', 'REVIEWING_GUIDE_UP', 'LOANING'].includes(this.status)) {
        this.statusIconInfo = this.animationOptions.wait
        anim = this.anims.wait
        hideAnims = [this.anims.success, this.anims.fail]
      } else if (this.status === 'SUCCESS') {
        this.statusIconInfo = this.animationOptions.success
        anim = this.anims.success
        hideAnims = [this.anims.wait, this.anims.fail]
      } else if (['FAILURE', 'FAILURE_REAL_TIME_REFUND'].includes(this.status)) {
        this.statusIconInfo = this.animationOptions.fail
        anim = this.anims.fail
        hideAnims = [this.anims.wait, this.anims.success]
      } else {
        this.statusIconInfo = null
      }
      if (anim) {
        this.setAnimations(anim)
      }
      hideAnims.filter(item => item !== null)
        .forEach(item => item.stop())
    },
    setAnimations (anim) {
      if (anim) {
        anim.resetSegments(true)
        anim.play()
      }
    },
    async getProductInfo () {
      const response = await this.upGuideInfo()
      const { success, data } = response
      if (success) {
        this.guideInfo = data
      }
    },
    toUpDetail () {
      this.$router.push('/vip/index?findTarget=UPC_M&noExit=Y')
    },
    protocolAction () {
      this.$router.push('/protocol/vip-wh')
    },
    checkShouldShowGuidePop () {
      if (this.isIntervalDay('withdrawResultUpGuidePop', 1) &&
        this.status === this.statusKeys.REVIEWING_GUIDE_UP) {
          this.guidePopVisible = true
          setKey('withdrawResultUpGuidePop', Date.now())
        }
    },
    buyAction () {
      this.guidePopVisible = false
      if (this.showVersionTipsDiff()) {
        this.showVersionTips = true
        return
      }
      WHPay(false, 'UPC_M', 'UP')
    },
    showVersionTipsDiff () {
      return isAndroid() &&
        hasNativeMethod('getUserInfo') &&
        getKey('appVersion') &&
        versionStringCompare('1.8.1.8', getKey('appVersion')) > 0
    },
    showServicePop () {
      this.servicePopVisible = true
    },
    callService () {
      mockHrefJump(`tel:4000100008`)
    },
    waitAnimationCreated (anim) {
      this.anims.wait = anim
    },
    successAnimationCreated (anim) {
      this.anims.success = anim
    },
    failAnimationCreated (anim) {
      this.anims.fail = anim
    },
    async pulldown () {
      await this.getLoanResult()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page-wrapper {
  .page {
    padding: 0 30px;
    .top {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      padding:30px 0;
      margin: 22px 0;
      .back {
        float: right;
        text-decoration: underline;
        text-align: right;
      }
    }
    .content {
      align-items: center;
      margin-top: 58px;
      .status-top {
        align-items: center;
        .icon {
          height: 210px;
          width: 210px;
        }
        .title {
          font-size: 42px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 59px;
          margin-top: 20px;
        }
        .desc {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 37px;
          margin-top: 15px;
          padding: 0 50px;
          text-align: center;
        }
      }
      .status-content {
        margin-top: 60px;
        width: 100%;
      }
    }
    .service {
      margin: 135px auto;
    }
  }
  /deep/.up-result-guide-pop {
    .default-content {
      background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
      padding: 0 45px;
      text-align: center;
      .top {
        align-items: flex-end;
        padding: 0;
        margin: 50px 0 0 0;
        text-align: left;
        .left {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          line-height: 45px;
          .amount {
            font-size: 70px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 98px;
          }
        }
        .right {
          width: 238px;
          height: 150px;
        }
      }
      .middle {
        width: 530px;
        height: 169px;
      }
      .bottom {
        margin-top: 30px;
        margin-bottom: 40px;
        .buy-button {
          width: 530px;
          height: 88px;
          background: linear-gradient(270deg, #D79663 0%, #E4B378 100%);
          border-radius: 47px;
          align-items: center;
          justify-content: space-between;
          padding: 0 30px;
          .price {
            font-size: 36px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 88px;
          }
          .origin {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 88px;
            opacity: 0.6;
            margin-left: 15px;
          }
          .ui-bubble {
            background-color: #000;
            opacity: 0.8;
            border-radius: 20px 20px 20px 0px;
            color: #fff;
            font-size: 20px;
            padding: 4px 20px;
            position: absolute;
            left: 55%;
            top: 410px;
            display: flex;
            height: 44px;
            align-items: center;
            .van-count-down {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffd8bc;
              line-height: 33px;
            }
          }
        }
        .protocol {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 33px;
          margin-top: 20px;
        }
      }
    }
  }
  .text-white {
    color: #ffffff;
  }
  .text-gray {
    color: #666666;
  }
  .text-dark {
    color: #333333;
  }
  .background-white {
    background: #ffffff;
  }
  .text-yellow {
    color: #763E12
  }
  .underlined {
    text-decoration: underline;
  }
  .line-through {
    text-decoration: line-through;
  }
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
}
</style>